import { memo } from "react";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import useKakaoMapsLoader from "./useKakaoMapsLoader";

const containerStyle = {
  width: "100%",
  height: "20rem",
};

function BranchMap({ branch }) {
  const { isLoaded } = useKakaoMapsLoader();
  if (!isLoaded || !branch?.coordinate) return null;
  return (
    <Map center={branch.coordinate} style={containerStyle} level={3}>
      <MapMarker position={branch.coordinate} title={branch.name} />
    </Map>
  );
}

export default memo(BranchMap);
